import { render } from "./admin-form-page.vue?vue&type=template&id=20e3c984"
import script from "./admin-form-page.vue?vue&type=script&lang=js"
export * from "./admin-form-page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__